import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import Timestamp from "../../ui/Timestamp"
import SortHeader from "../sorting/SortHeader"
import TextFilter from "../filters/TextFilter"
import IDLink from "../../ui/IDLink"
import Text from "../../ui/Text"

/**
 * Renders a list of user action logs matching the filters
 *
 * @param actions
 * @param filter
 * @param setFilter
 * @param stickyHeader
 * @returns {JSX.Element}
 * @constructor
 */
const ActionsTable = ({
  actions = [],
  filter = {},
  setFilter = () => {},
  stickyHeader = true,
  hideUserAccount = false,
}) => {
  const advancedMode = useSelector(selectAdvancedMode)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        <TableHeader>#</TableHeader>
        <TableHeader
          sortControl={
            <SortHeader
              setFilter={setFilter}
              filter={filter}
              sortBy={"action"}
            />
          }
        >
          Action
        </TableHeader>
        <TableHeader>Outcome</TableHeader>
        {!hideUserAccount && (
          <TableHeader
            filterControl={
              <TextFilter
                filterByName="by_ctns"
                filter={filter}
                setFilter={setFilter}
                active={filter?.name_ctns ? true : false}
              />
            }
            sortControl={
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"account_id"}
              />
            }
          >
            User Account
          </TableHeader>
        )}
        <TableHeader>Metadata</TableHeader>
        <TableHeader
          sortControl={
            <SortHeader setFilter={setFilter} filter={filter} sortBy={"at"} />
          }
        >
          At
        </TableHeader>
      </TableHeaderRow>
      {actions && (
        <tbody>
          {actions.map((act, i) => (
            <Row key={act.id} zebra>
              <Cell>
                <Text secondary>{i + 1}.</Text>
              </Cell>
              <Cell>{act.action}</Cell>
              <Cell>
                <Text
                  success={act.success === true}
                  error={act.success === false}
                >
                  {act.success === true
                    ? "success"
                    : act.success === false
                    ? "failed"
                    : "-"}
                </Text>
              </Cell>
              {!hideUserAccount && (
                <Cell>
                  {act.by_id && (
                    <IDLink to={`/accounts/${act.by_id}`}>{act.by_id}</IDLink>
                  )}
                </Cell>
              )}
              <Cell>
                <Text smaller secondary>
                  {act?.data &&
                    Object.keys(act?.data).map((key) => (
                      <div key={key}>
                        <strong>{key}:</strong> {act?.data[key]}
                      </div>
                    ))}
                </Text>
              </Cell>
              <Cell>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {act.at}
                </Timestamp>
              </Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

ActionsTable.propTypes = {
  actions: PropTypes.array, // the actions to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
  hideUserAccount: PropTypes.bool, // If provided hides the user account column for the table
}

export default ActionsTable
